import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { RegisterPageRoutingModule } from './register-routing.module';

import { RegisterPage } from './register.page';
import { TranslateModule } from '@ngx-translate/core';
import { ValidatorsModule } from 'src/app/core/validators/validators.module.';
import { PasswordStrengthMeterModule } from '../password-strength-meter/password-strength-meter.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    IonicModule,
    RegisterPageRoutingModule,
    TranslateModule,
    ValidatorsModule,
    PasswordStrengthMeterModule
  ],
  declarations: [RegisterPage]
})
export class RegisterPageModule {}
